import Phaser from "phaser";

let game = null;

const STD_MIN_TIME = 1000;
const STD_TIME_DELAY = 3000;
const STD_TIME_DECREASE = 50;

var cursors;

const LANG_NL = "nl-BE";
const LANG_FR = "fr-BE";

var locale = LANG_NL;
var languageManager;
var swipeManager;

var positions = [100, 230, 360, 475, 605, 730, 860];
var middle = Math.floor(positions.length / 2);
var timeDecrease = STD_TIME_DECREASE;
var timeDelay = STD_TIME_DELAY;
var minTime = STD_MIN_TIME;
var gameOver = false;
var playtime = 0;

var crows = [];
var CrowPool;

var seeds = [{type: 2, x: 80, y: 430, row: 0, active: true, image: null},
  {type: 4, x: 40, y: 465, row: 0, active: true, image: null},
  {type: 1, x: 220, y: 450, row: 1, active: true, image: null},
  {type: 3, x: 170, y: 510, row: 1, active: true, image: null},
  {type: 1, x: 350, y: 465, row: 2, active: true, image: null},
  {type: 4, x: 350, y: 465, row: 2, active: true, image: null},
  {type: 5, x: 350, y: 520, row: 2, active: true, image: null},
  {type: 5, x: 470, y: 450, row: 3, active: true, image: null},
  {type: 2, x: 480, y: 510, row: 3, active: true, image: null},
  {type: 4, x: 605, y: 435, row: 4, active: true, image: null},
  {type: 1, x: 620, y: 510, row: 4, active: true, image: null},
  {type: 5, x: 720, y: 440, row: 5, active: true, image: null},
  {type: 3, x: 750, y: 490, row: 5, active: true, image: null},
  {type: 2, x: 780, y: 505, row: 5, active: true, image: null},
  {type: 1, x: 900, y: 450, row: 6, active: true, image: null},
  {type: 5, x: 940, y: 490, row: 6, active: true, image: null}];

const scarecrowGameAtlas = require("Images/games/scarecrow-game/atlas_scarecrow-game.png");
const scarecrowGameAtlasJson = require("Data/games/atlas_scarecrow-game.json");

class Game extends Phaser.Scene {
  constructor() {
    super({key: "Game"});
    this.bestTime = 0;
  }

  init() {
    this.scene.launch("ScarecrowGame", {gameScene: this})
      .launch("InGameMenu", {gameScene: this});
  }

  create() {
    this.scarecrowGame = this.scene.get("ScarecrowGame");
    this.ingameMenu = this.scene.get("InGameMenu");

    this.setSceneOrder();

    this.cursors = this.input.keyboard.addKeys({
      leftKey: Phaser.Input.Keyboard.KeyCodes.LEFT,
      rightKey: Phaser.Input.Keyboard.KeyCodes.RIGHT
    });

    this.scarecrowGame.events.off("pauseGame").on("pauseGame", this.showInfo, this);
    this.scarecrowGame.events.off("endGame").on("endGame", this.endGame, this);
    this.ingameMenu.events.off("continueGame").on("continueGame", this.hideInfo, this);
    this.ingameMenu.events.off("restartGame").on("restartGame", this.restartGame, this);
  }

  setSceneOrder() {
    this.scene.bringToTop("InGameMenu");
    this.scene.bringToTop("ScarecrowGame");
  }

  update(time, delta) {
    this.scarecrowGame.updateInput(this.cursors);
  }

  showInfo() {
    this.scarecrowGame.pause(true);
    this.ingameMenu.showMenu(PAUSE_MENU);
    this.scene.bringToTop("InGameMenu");
  }
  hideInfo() {
    this.scene.bringToTop("ScarecrowGame");
    this.ingameMenu.hide();
    this.scarecrowGame.pause(false);
  }
  restartGame() {
    this.scarecrowGame.restart();
    this.ingameMenu.hide();
    this.scene.bringToTop("ScarecrowGame");
  }
  endGame(time)
  {
    this.scarecrowGame.infoBtnZone.removeInteractive();
    this.scarecrowGame.pause(true);
    this.ingameMenu.showMenu(END_MENU);
    this.ingameMenu.setScore(time);
    this.scene.bringToTop("InGameMenu");
  }
}

class ScarecrowGame extends Phaser.Scene {
  constructor() {
    super({key: "ScarecrowGame"});
  }

  init() {
  }

  create() {

    this.add.image(0, 0, 'scarecrow', 'scene/sky.jpg');
    this.add.sprite(0, 300, 'scarecrow', 'scene/back.png');
    this.add.sprite(0, 332, 'scarecrow', 'scene/front.png');
    var infoBtn = this.add.sprite(40, 40, 'scarecrow', 'interface/info.png');

    var prepareJumpFrames = this.anims.generateFrameNames('scarecrow', {
      start: 1,
      end: 2,
      zeroPad: 2,
      prefix: 'victor/victor_',
      suffix: '.png'
    });
    this.anims.create({
      key: 'prepareJumpLeft',
      frames: prepareJumpFrames,
      frameRate: 10,
      repeat: 0,
      onComplete: this.jump,
      onCompleteParams: [this, -1]
    });
    this.anims.create({
      key: 'prepareJumpRight',
      frames: prepareJumpFrames,
      frameRate: 10,
      repeat: 0,
      onComplete: this.jump,
      onCompleteParams: [this, 1]
    });
    var jumpUpFrames = this.anims.generateFrameNames('scarecrow', {
      start: 2,
      end: 3,
      zeroPad: 2,
      prefix: 'victor/victor_',
      suffix: '.png'
    });
    this.anims.create({key: 'jumpUp', frames: jumpUpFrames, frameRate: 60, repeat: 0});
    var comeDownFrames = this.anims.generateFrameNames('scarecrow', {
      start: 4,
      end: 6,
      zeroPad: 2,
      prefix: 'victor/victor_',
      suffix: '.png'
    });
    this.anims.create({
      key: 'comeDown', frames: comeDownFrames, frameRate: 10, repeat: 0, onComplete: this.jumpEnded, onCompleteParams: [this]
    });

    this.timerText = this.add.text(game.config.width - 120, 10, '00:00', {font: '48px RabbitOnTheMoon', fill: '#8BB000'});

    for (var i = 0; i < seeds.length; i++) {
      seeds[i].image = this.add.sprite(seeds[i].x, seeds[i].y, 'scarecrow', 'seeds/seed_0' + seeds[i].type + '.png');
    }

    this.player = new Victor(this, config.width / 2, 445, middle);


    this.ground = this.physics.add.staticGroup();
    var floor = this.add.sprite(400, 460);
    floor.displayWidth = 800;
    this.ground.add(floor);
    this.ground.refresh();
    this.physics.add.collider(this.player.sprite, this.ground);

    cursors = this.input.keyboard.createCursorKeys();

    CrowPool = this.add.group({classType: Crow, maxSize: positions.length, runChildUpdate: false});

    this.playtime = 0;
    this.gameTick = this.time.addEvent({delay: 1000, callback: this.tick, callbackScope: this, loop: true});


    this.events.off("scare-birds").on("scare-birds", this.scareBirds);

    this.infoBtnZone = this.add.zone(
      infoBtn.x - (infoBtn.width * infoBtn.originX) - 5,
      infoBtn.y - (infoBtn.height * infoBtn.originY) - 5,
      infoBtn.width + 10,
      infoBtn.height + 10
    ).setName("info-button");

    this.setInfoBtnEvent();
    this.infoBtnZone.setInteractive();

    this.input.on("gameobjectover", function (pointer, gameObject) {
      if (gameObject.name === "info-button") {
        this.mouse.target.style.cursor = "pointer";
      }
    });

    this.input.on("gameobjectout", function (pointer, gameObject) {
      if (gameObject.name === "info-button") {
        this.mouse.target.style.cursor = "";
      }
    });

    this.paused = false;
    this.gameOver = false;
    swipeManager.setCallback(this, this.swipeCallback);
  }

  setInfoBtnEvent() {
    this.infoBtnZone.on("pointerup", () =>
    {
      this.input.mouse.target.style.cursor = "";
      this.events.emit("pauseGame");
  })
    ;
  }

  update() {
    if (!this.gameOver && !this.paused) {

      if (cursors.left.isDown && this.player.row > 0 && !this.player.jumping) {
        this.player.prepareJump(-1);
      }
      else if (cursors.right.isDown && this.player.row < positions.length - 1 && !this.player.jumping) {
        this.player.prepareJump(1);
      }
      if (this.spawnTimer == null && !this.gameOver && !this.paused) {
        this.spawnTimer = this.time.delayedCall(Math.random() * timeDelay + minTime, this.spawnBird, [], this);
      }

      if(this.input.activePointer.isDown)
      {
        swipeManager.swipeInput(this.input.activePointer);
      }
      else
      {
        swipeManager.endSwipe();
      }

    }
  }

  swipeCallback(scene, direction)
  {
    console.log("swipeCallback received");
    scene.player.prepareJump(direction);
  }

  updateInput(cursors) {

  }
  pause(state)
  {
    this.paused = state;
    if(state)
      this.tweens.pauseAll();
    else
      this.tweens.resumeAll();

    for(var i=0; i<crows.length; i++)
    {
      crows[i].crow.pause(state);
    }
  }

  tick() {
    if(!this.paused && !this.gameOver) {
      this.playtime++;
      this.timerText.setText(('0' + Math.floor(this.playtime / 60)).slice(-2) + ':' + ('0' + this.playtime % 60).slice(-2));
      this.scareBirds();
      this.checkGameOver();
    }
  }

  checkGameOver() {
    var activeRows = [];
    for (var i = 0; i < seeds.length; i++) {
      if (seeds[i].active && activeRows.indexOf(seeds[i].row) == -1)
        activeRows.push(seeds[i].row)
    }
    if (activeRows.length <= positions.length / 2) {
      this.gameOver = true;
      this.events.emit("endGame", this.playtime);
    }
  }
  restart()
  {
    this.infoBtnZone.setInteractive();
    this.playtime = 0;
    this.timerText.setText(('0' + Math.floor(this.playtime / 60)).slice(-2) + ':' + ('0' + this.playtime % 60).slice(-2));


    for (var i = 0; i < seeds.length; i++) {
      seeds[i].active = true;
      seeds[i].image.setVisible(true);
    }

    /*this.tweens.killAll();*/

    CrowPool.clear();

    for(var j = 0; j<crows.length; j++)
    {
      crows[j].crow.setVisible(false);
      crows[j].crow.destroy();
    }
    crows = [];


    CrowPool = this.add.group({classType: Crow, maxSize: positions.length, runChildUpdate: false});

    this.player.reset();

    timeDecrease = STD_TIME_DECREASE;
    timeDelay = STD_TIME_DELAY;
    minTime = STD_MIN_TIME;
    this.gameOver = false;
    this.pause(false);

  }

  jump(sprite, animation, scene, direction) {

    var originalY = scene.player.sprite.body.y;
    scene.tweens.add({
      targets: scene.player.sprite,
      x: positions[scene.player.row + direction],
      ease: 'Linear',
      duration: 500,
      onComplete: scene.finalizeJump,
      onCompleteParams: [scene]
    });

    scene.tweens.add({
      targets: scene.player.sprite,
      y: 410,
      ease: 'Back.easeOut',
      duration: 400
    });

    scene.player.row += direction;
    scene.player.sprite.anims.play('jumpUp');
  }

  finalizeJump(tween, targets, scene) {
    scene.player.finalizeJump();
    scene.scareBirds();
  }
  jumpEnded(sprite, animation, scene)
  {
    scene.player.jumping = false;
  }

  scareBirds() {
    var newArray = [];
    for (var i = 0; i < crows.length; i++) {
      if (crows[i].row == this.player.row || crows[i].crow.seed.active == false) {
        crows[i].crow.flyOff();
      }
      else
        newArray.push(crows[i]);
    }
    crows = newArray;
  }

  spawnBird() {
    if(!this.paused && !this.gameOver) {
      var crowTarget = this.getFreeRowAndSeed();
      if (crowTarget.spawnRow >= 0 && crowTarget.seed != null) {
        //this.spawning = true;
        var crow = CrowPool.get();
        if (crow) {
          crow.launch(crowTarget.spawnRow, crowTarget.seed);
          crows.push({crow: crow, row: crowTarget.spawnRow});
        }
      }
      this.timeDelay -= Math.random() * timeDecrease;

    }
    this.spawnTimer.destroy();
    this.spawnTimer = null;
  }

  getFreeRowAndSeed() {
    var possibilities = [];
    for (var i = 0; i < positions.length; i++) {
      var available = true;
      for (var j = 0; j < crows.length; j++) {
        if (crows[j].row == i)
          available = false;
      }
      if (available && i != this.player.row) {
        //suitable row, check available seeds
        var seed = this.getSeed(i);
        if (seed != null)
          possibilities.push({spawnRow: i, seed: seed});
      }

    }
    if (possibilities.length > 0)
      return possibilities[Math.floor(Math.random() * possibilities.length)];
    else
      return -1;
  }

  getSeed(row) {
    var possibilities = [];
    for (var i = 0; i < seeds.length; i++) {
      if (seeds[i].row == row && seeds[i].active == true)
        possibilities.push(seeds[i]);
    }
    if (possibilities.length > 0)
      return possibilities[Math.floor(Math.random() * possibilities.length)];
    else
      return null;
  }
}

class Victor {
  constructor(scene, x, y, row) {
    this.scene = scene;
    this.sprite = this.scene.physics.add.sprite(x, y, 'scarecrow', 'victor/victor_01.png');
    this.jumping = false;
    this.row = row;
    this.direction = 0;
    this.sprite.setBounce(0);
    this.sprite.setCollideWorldBounds(true);
    this.origin = {x: this.sprite.body.x, y: this.sprite.body.y, row: row};

    this.sprite.on("animationcomplete", this.onAnimComplete, this);
  }

  onAnimComplete(animation, frame)
  {
    if(animation.key === "prepareJumpLeft")
    {
      this.scene.jump(frame, animation, this.scene, -1);
    }
    else if(animation.key === "prepareJumpRight")
    {
      this.scene.jump(frame, animation, this.scene, 1);
    }
    else if(animation.key === "comeDown")
    {
      this.scene.jumpEnded(frame, animation, this.scene);
    }
  }

  prepareJump(direction) {
    if(!this.jumping) {
      this.jumping = true;
      this.direction = direction;
      if (direction < 0)
        this.sprite.anims.play('prepareJumpLeft');
      else
        this.sprite.anims.play('prepareJumpRight');
    }
  }

  finalizeJump() {
    this.sprite.anims.play('comeDown');
  }

  reset()
  {
    this.sprite.anims.play('comeDown');
    this.sprite.setPosition(this.origin.x, this.origin.y);
    this.jumping = false;
    this.row = this.origin.row;
    this.direction = 0;

  }
}

class Loader extends Phaser.Scene {
  constructor() {
    super({key: "Loader"});
  }

  init() {
    this.add.text(this.sys.game.config.width / 2, this.sys.game.config.height / 2, "Loading...", {
      fontFamily: "RabbitOnTheMoon",
      fontSize: 18,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);
  }

  preload() {
    this.load.atlas('scarecrow', scarecrowGameAtlas, scarecrowGameAtlasJson);
    this.loadFonts();
  }

  create() {

    var landFrames = this.anims.generateFrameNames('scarecrow', {
      start: 1,
      end: 3,
      zeroPad: 2,
      prefix: 'bird/bird_',
      suffix: '.png'
    });
    this.anims.create({
      key: 'land', frames: landFrames, frameRate: 2, repeat: 0, onComplete: function () {
      }
    });
    var peckFrames = this.anims.generateFrameNames('scarecrow', {
      start: 3,
      end: 4,
      zeroPad: 2,
      prefix: 'bird/bird_',
      suffix: '.png'
    }).concat(this.anims.generateFrameNames('scarecrow', {
      start: 3,
      end: 3,
      zeroPad: 2,
      prefix: 'bird/bird_',
      suffix: '.png'
    }));
    this.anims.create({
      key: 'peck', frames: peckFrames, frameRate: 10, repeat: 0, onComplete: function () {
      }
    });
    var flyOffFrames = this.anims.generateFrameNames('scarecrow', {
      start: 1,
      end: 6,
      zeroPad: 2,
      prefix: 'bird/fly_',
      suffix: '.png'
    }).concat(this.anims.generateFrameNames('scarecrow', {
      start: 3,
      end: 6,
      zeroPad: 2,
      prefix: 'bird/fly_',
      suffix: '.png'
    }));
    this.anims.create({
      key: 'flyOff', frames: flyOffFrames, frameRate: 5, repeat: 0, onComplete: function () {
      }
    });

    languageManager = new LanguageManager(locale);
    swipeManager = new SwipeManager();

    this.scene.start("Menu");
  }

  loadFonts() {
    this.preloadFont("RabbitOnTheMoon");
    this.preloadFont("AbadiMTPro-CondExtraBold");
  }

  preloadFont(font) {
    var text = this.add.text(0, 0, "text", {fontFamily: font, fontSize: 1, fill: "#FFFFFF"});
    text.visible = false;
  }
}

class Menu extends Phaser.Scene {
  constructor() {
    super({key: "Menu"});
  }

  init() {
  }

  create() {
    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.add.image(0, 0, 'scarecrow', 'scene/sky.jpg');
    this.add.sprite(0, 330, 'scarecrow', 'scene/back.png');
    this.add.sprite(0, 362, 'scarecrow', 'scene/front.png');
    this.add.image(0, 0, 'scarecrow', 'interface/background_overlay.png');
    this.add.image(0, 0, 'scarecrow', 'interface/background_cloud.png');
    this.add.image(gameWidth / 2, gameHeight * 0.6, 'scarecrow', 'interface/paint_green.png');
    this.add.image(gameWidth / 2, gameHeight * 0.6, 'scarecrow', 'interface/birds.png');
    var buttonImage = this.add.image(gameWidth / 2, gameHeight * 0.9, 'scarecrow', 'interface/button.png');

    var playicon = this.add.image(gameWidth / 2, gameHeight * 0.9, 'scarecrow', 'interface/icon_play.png');
    var text = this.add.text(gameWidth / 2, gameHeight * 0.9, "  "+languageManager.getText().menu.button, {
      fontFamily: "RabbitOnTheMoon",
      fontSize: 20,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);
    var fullWidth = playicon.width + text.width;
    playicon.setPosition(gameWidth / 2 - (fullWidth / 2) + playicon.width / 2, gameHeight * 0.9);
    text.setPosition(gameWidth / 2 + playicon.width * 0.5, gameHeight * 0.9 + (playicon.height / 10));

    this.add.text(gameWidth / 2, gameHeight * 0.15, languageManager.getText().menu.title, {
      fontFamily: "RabbitOnTheMoon",
      fontSize: 30,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);
    var description = this.add.text(gameWidth / 2, gameHeight * 0.3, languageManager.getText().menu.description, {
      fontFamily: "AbadiMTPro-CondExtraBold",
      fontSize: 18,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);

    this.add.image(description.x + description.width / 2, description.y + description.height * 0.75, 'scarecrow', 'interface/icon_gameplay.png').setOrigin(0, 1);

    this.playBtnZone = this.add.zone(
      buttonImage.x - (buttonImage.width * buttonImage.originX) - 5,
      buttonImage.y - (buttonImage.height * buttonImage.originY) - 5,
      buttonImage.width + 10,
      buttonImage.height + 10
    ).setName("play-button");

    this.setPlayBtnEvent();
    this.playBtnZone.setInteractive();

    this.input.on("gameobjectover", function (pointer, gameObject) {
      if (gameObject.name === "play-button") {
        this.mouse.target.style.cursor = "pointer";
      }
    });

    this.input.on("gameobjectout", function (pointer, gameObject) {
      if (gameObject.name === "play-button") {
        this.mouse.target.style.cursor = "";
      }
    });
  }

  setPlayBtnEvent() {
    this.playBtnZone.once("pointerup", () =>
    {
      this.input.mouse.target.style.cursor = "";
    this.scene.start("Game");
  })
    ;
  }
}

const PAUSE_MENU = "pause-menu";
const END_MENU = "end-menu";

class InGameMenu extends Phaser.Scene {
  constructor() {
    super({key: "InGameMenu"});
  }

  init() {
  }

  create() {

    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.add.image(0, 0, 'scarecrow', 'scene/sky.jpg');
    this.add.sprite(0, 300, 'scarecrow', 'scene/back.png');
    this.add.sprite(0, 332, 'scarecrow', 'scene/front.png');
    this.add.image(0, 0, 'scarecrow', 'interface/background_overlay.png');

    this.bestTime = 0;
    this.bestTimeLabel;

    this.pauseGroup = this.add.group();
    this.endGameGroup = this.add.group();

    this.createEndGameMenu(gameWidth, gameHeight);
    this.createPauseMenu(gameWidth, gameHeight);

    this.hide();
  }

  continue(scene) {
    scene.events.emit("continueGame");

  }
  restart(scene){
    scene.events.emit("restartGame");

  }

  showMenu(type)
  {
    if(type == PAUSE_MENU)
    {
      this.setVisibility(this.endGameGroup, false);
      this.setVisibility(this.pauseGroup, true);
    }
    else
    {
      this.setVisibility(this.endGameGroup, true);
      this.setVisibility(this.pauseGroup, false);
    }

  }

  createEndGameMenu(gameWidth, gameHeight)
  {
    var restartButton = new UIButton(this, gameWidth / 2, gameHeight * 0.8,"replay-button",this.restart);
    this.endGameGroup.add(restartButton.buttonImage);
    this.endGameGroup.add(restartButton.uiBtnZone);

    var playicon = this.add.image(gameWidth / 2, gameHeight * 0.8, 'scarecrow', 'interface/icon_restart.png');
    var text = this.add.text(gameWidth / 2, gameHeight * 0.8, "  " + languageManager.getText().gameOver.retry, {
      fontFamily: "AbadiMTPro-CondExtraBold",
      fontSize: 20,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);
    var fullWidth = playicon.width + text.width;
    playicon.setPosition(gameWidth / 2 - (fullWidth / 2) + playicon.width / 2, gameHeight * 0.8);
    text.setPosition(gameWidth / 2 + playicon.width * 0.5, gameHeight * 0.8);

    this.endGameGroup.add(playicon);
    this.endGameGroup.add(text);

    this.endGameGroup.add(this.add.text(gameWidth / 2, gameHeight * 0.25, languageManager.getText().gameOver.title, {
      fontFamily: "RabbitOnTheMoon",
      fontSize: 50,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5));


    this.bestTimeLabel = this.add.text(gameWidth / 2, gameHeight * 0.5, languageManager.getText().gameOver.time + " 00:00", {
      fontFamily: "RabbitOnTheMoon",
      fontSize: 35,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);

    this.endGameGroup.add(this.bestTimeLabel);

  }
  createPauseMenu(gameWidth, gameHeight)
  {

    var continueButton = new UIButton(this, gameWidth / 2, gameHeight * 0.65,"continue-button",this.continue);
    this.pauseGroup.add(continueButton.buttonImage);
    this.pauseGroup.add(continueButton.uiBtnZone);

    var restartButton = new UIButton(this, gameWidth / 2, gameHeight * 0.8,"restart-button",this.restart);
    this.pauseGroup.add(restartButton.buttonImage);
    this.pauseGroup.add(restartButton.uiBtnZone);

    var playIcon = this.add.image(gameWidth / 2, gameHeight * 0.65, 'scarecrow', 'interface/icon_play.png');
    var continueText = this.add.text(gameWidth / 2, gameHeight * 0.65, "  " + languageManager.getText().pauze.continue, {
      fontFamily: "AbadiMTPro-CondExtraBold",
      fontSize: 20,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);
    var fullWidth = playIcon.width + continueText.width;
    playIcon.setPosition(gameWidth / 2 - (fullWidth / 2) + playIcon.width / 2, gameHeight * 0.65);
    continueText.setPosition(gameWidth / 2 + playIcon.width * 0.5, gameHeight * 0.65);

    this.pauseGroup.add(playIcon);
    this.pauseGroup.add(continueText);

    var restartIcon = this.add.image(gameWidth / 2, gameHeight * 0.8, 'scarecrow', 'interface/icon_restart.png');
    var restartText = this.add.text(gameWidth / 2, gameHeight * 0.8, "  " + languageManager.getText().pauze.replay, {
      fontFamily: "AbadiMTPro-CondExtraBold",
      fontSize: 20,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5);
    var fullWidth = restartIcon.width + restartText.width;
    restartIcon.setPosition(gameWidth / 2 - (fullWidth / 2) + restartIcon.width / 2, gameHeight * 0.8);
    restartText.setPosition(gameWidth / 2 + restartIcon.width * 0.5, gameHeight * 0.8);

    this.pauseGroup.add(restartIcon);
    this.pauseGroup.add(restartText);

    this.pauseGroup.add(this.add.text(gameWidth / 2, gameHeight * 0.25, languageManager.getText().pauze.title, {
      fontFamily: "RabbitOnTheMoon",
      fontSize: 80,
      fontWeight: "normal",
      fill: "#FFFFFF"
    }).setOrigin(0.5));
  }

  setVisibility(group, state)
  {
    var children = group.getChildren();
    for(var i = 0; i < children.length; i++)
    {
      children[i].setVisible(state);
    }
  }

  setScore(time)
  {
    if(this.bestTime < time)
      this.bestTime = time;
    this.bestTimeLabel.setText(languageManager.getText().gameOver.time + " " + ('0' + Math.floor(this.bestTime / 60)).slice(-2) + ':' + ('0' + this.bestTime % 60).slice(-2));
  }

  hide()
  {
    this.setVisibility(this.endGameGroup, false);
    this.setVisibility(this.pauseGroup, false);
  }

}

class UIButton{
  constructor(scene, x, y, name, callback)
  {
      this.buttonImage = scene.add.image(x, y, 'scarecrow', 'interface/button.png');

      this.uiBtnZone = scene.add.zone(
        this.buttonImage.x - (this.buttonImage.width * this.buttonImage.originX) - 5,
        this.buttonImage.y - (this.buttonImage.height * this.buttonImage.originY) - 5,
        this.buttonImage.width + 10,
        this.buttonImage.height + 10
      ).setName(name);

      this.uiBtnZone.setInteractive();

      scene.input.on("gameobjectover", function (pointer, gameObject) {
        if (gameObject.name === name) {
          scene.input.mouse.target.style.cursor = "pointer";
        }
      });

      scene.input.on("gameobjectout", function (pointer, gameObject) {
        if (gameObject.name === name) {
          scene.input.mouse.target.style.cursor = "";
        }
      });

      this.uiBtnZone.on("pointerup", () =>
      {
        console.log("pointerup triggered");
        scene.input.mouse.target.style.cursor = "";
        callback(scene);

    });
  }
  setVisible(state)
  {
    this.buttonImage.setVisible(state);
    this.setInteractive(state);
  }
  setInteractive(state)
  {
      this.uiBtnZone.input.enabled = state;
  }
}

class Crow extends Phaser.GameObjects.Sprite {
  constructor(scene) {
    super(scene, 0, 0, 'scarecrow', 'bird/bird_01.png').setScale(0.8);
    this.peckCooldown = Math.random() * 500 + 750;
    this.timedEvent = null;
    this.fedEvent = null;
    this.direction = 1;
    this.seed = null;
    this.scared = false;
    this.paused = false;
  }

  launch(row, seed) {
    this.seed = seed;
    this.scared = false;
    var offset = config.width / 4;
    //determine initial direction
    if (row <= middle) {
      offset = -offset;
      this.direction = -1;
    }
    //flip direction for outer fields
    if (row == 0 || row == positions.length - 1) {
      offset = -offset;
      this.direction = -this.direction;
    }
    this.scaleX = this.direction * this.scaleX;


    this.setPosition(positions[row] + offset, -50);
    this.setActive(true);
    this.setVisible(true);
    this.anims.play('land');

    this.scene.tweens.add({
      targets: this,
      x: seed.x + (seed.image.width / 2 * this.scaleX),
      ease: 'Quad.easeIn',
      duration: 1000,
      onComplete: function () {
      }
    });

    this.scene.tweens.add({
      targets: this,
      y: seed.y,
      ease: 'Quad.easeOut',
      duration: 1000,
      onComplete: function () {
        for (var i = 0; i < this.targets.length; i++) {
          this.targets[i].landCrow();
        }
      }
    });
  }

  update() {
  }

  landCrow() {
    if (!this.scared && !this.paused) {
      this.doPeck();
      this.fedEvent = this.scene.time.delayedCall(Math.random() * (STD_TIME_DELAY / 2) + STD_MIN_TIME, this.hasFed, [], this);
    }
  }

  flyOff() {
    this.scared = true;
    if (this.timedEvent)
      this.timedEvent.destroy();
    if (this.fedEvent)
      this.fedEvent.destroy();
    this.anims.play('flyOff');

    var offscreen = game.config.width + this.x;
    if (this.direction > 0)
      offscreen = this.x - game.config.width;

    this.scene.tweens.add({
      targets: this,
      x: offscreen,
      ease: 'Quad.easeIn',
      duration: 1500,
      onComplete: function () {
      }
    });

    this.scene.tweens.add({
      targets: this,
      y: Math.random() * 200,
      ease: 'Quad.easeOut',
      duration: 2000,
      onComplete: function () {
        for (var i = 0; i < this.targets.length; i++) {
          this.targets[i].remove();
        }
      }
    });

  }

  doPeck() {
    if (!this.scared && this.active) {
      this.anims.play('peck');
      this.peckCooldown = Math.random() * 800 + 100;
      this.timedEvent = this.scene.time.delayedCall(this.peckCooldown, this.doPeck, [], this);
    }
  }

  hasFed() {
    if (this.seed != null && !this.scared && !this.paused) {
      this.seed.image.setVisible(false);
      this.seed.active = false;
    }
  }
  remove() {
    this.setPosition(-50, -50);
    if (this.timedEvent)
      this.timedEvent.destroy();
    if (this.fedEvent)
      this.fedEvent.destroy();
    this.scaleX = 0.8;
    this.direction = 1;
    this.seed = null;
    this.paused = false;
    this.active = false;
    this.visible = false;
  }
  pause(state)
  {
    //if the fedEvent is live, cancel it when pause is triggered
    if(this.fedEvent) {
      if (state) {
        this.fedEvent.paused = true;
        this.fedEvent.remove();
        this.fedEvent.destroy();
      }
    }
    else(this.paused && !state) //if current state switches from paused to live, create a new fedEvent
    {
      this.fedEvent = this.scene.time.delayedCall(Math.random() * (STD_TIME_DELAY / 2) + STD_MIN_TIME, this.hasFed, [], this);
      this.doPeck();
    }
    this.paused = state;
  }
}

const NL = {
  menu: {
    title: "PROBEER DE ZAADJES TE REDDEN!",
    description: [
      "Swipe naar links of rechts op je scherm of duw op de pijltjestoetsen",
      "om Viktor de vogelverschrikker te laten springen. Jaag alle vogels",
      "weg voor ze de zaadjes oppikken en de oogst mislukt. Het spel",
      "stopt wanneer vier rijen geen zaadjes hebben."
    ],
    button: "Start het spel"
  },
  pauze: {
    title: "PAUZE",
    continue: "Verder spelen",
    replay: "Nieuw spel starten"
  },
  gameOver: {
    title: "GOED GEPROBEERD!",
    time: "BESTE TIJD ",
    retry: "Probeer het nog eens"
  }
};

const FR = {
  menu: {
    title: "SAUVE LES SEMENCES !",
    description: [
      "Fais glisser ton écran vers la gauche ou la droite ou appuie sur les",
      "flèches pour faire sauter Viktor et l’aider à chasser les oiseaux",
      "avant qu’ils aient mangé toutes les graines. Le jeu s’arrête quand",
      "4 rangées n’ont plus de graines."
    ],
    button: "Démarrer le jeu"
  },
  pauze: {
    title: "Pause",
    continue: "Reprend le jeu",
    replay: "Rejouer"
  },
  gameOver: {
    title: "BIEN JOUÉ !",
    time: "Meilleur temps ",
    retry: "Réessayer"
  }
};

class LanguageManager{
  constructor(lang){
    this.language = lang;
    this.text = NL;
    if(lang == LANG_FR)
      this.text = FR;
  }
  getText(key)
  {
    return this.text;
  }
}

class SwipeManager{
  constructor(){
    this.isSwiping = false;
    this.swipeDirection = 0;
    this.swipeDuration = 0;
    this.swipeDistance = 0;
    this.swipeXOrigin = 0;
    this.triggeredCallback = false;
    this.callback = null;
    this.scene = null;
  }
  setCallback(scene, fn)
  {
    this.callback = fn;
    this.scene = scene;
  }
  swipeInput(touch)
  {
    if(!this.isSwiping)
    {
      this.isSwiping = true;
      this.swipeXOrigin = touch.position.x;
    }
    else
    {
      this.swipeDistance = touch.position.x - this.swipeXOrigin;
      if(Math.abs(this.swipeDistance) > 50 && !this.triggeredCallback)
      {
        this.swipeDirection = 1;
        if(this.swipeDistance < 0)
          this.swipeDirection = -1;
        console.log("trigger callback");
        if(this.callback != null)
          this.callback(this.scene, this.swipeDirection);
        this.triggeredCallback = true;

      }
    }
  }
  endSwipe()
  {
    if(this.isSwiping) {
      console.log("swiping ended: " + this.swipeDistance);
      this.isSwiping = false;
      this.swipeDistance = 0;
      this.swipeDirection = 0;
      this.triggeredCallback = false;
    }
  }
}

var config = {
  type: Phaser.AUTO,
  width: 960,
  height: 540,
  canvasStyle: "display: block; margin: 0 auto;",
  backgroundColor: "#ffffff",
  physics: {
    default: 'arcade',
    arcade: {
      gravity: {y: 1000}
    }
  },
  scene: [Loader, Menu, Game, ScarecrowGame, InGameMenu]
};

export default function init(parent, pLocale)
{
  locale = pLocale;
  config.parent = parent;

  game = new Phaser.Game(config);
  return game;
}



// WEBPACK FOOTER //
// ./app/js/games/scarecrow-game/index.js